import * as React from 'react';
import Se360UserForm from './Se360UserForm';
import { Translate } from '../../shared/LanguageService';
import { Modal, Button } from 'react-bootstrap';
import ISe360User from './ISe360User';
import { handleError } from '../../shared/ErrorCatching';
import { assign } from '../../shared/Assign';
import { connect } from 'react-redux';
import * as Actions from './Actions';
import notify from '../../shared/feedback/notifications';

export class Se360UserModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            input: assign({}, this.props.emptyInput),
            availableRoles: [],
            availableCountries: [],
            availableLanguages: [],
            creating: false,
            errors: {}
        };

        this.onFormInputChange = this.onFormInputChange.bind(this);
        this.save = this.save.bind(this);
        this.create = this.create.bind(this);
        this.update = this.update.bind(this);
    }

    componentDidMount(): void {
        if (this.props.editId > 0) {
            this.props.actions
                .edit(this.props.editId)
                .then(() => {
                    this.setState({
                        input: assign({}, this.props.edit.user),
                        availableRoles: this.props.edit.availableRoles,
                        availableLanguages: this.props.edit.availableLanguages,
                        availableCountries: []
                    });
                })
                .catch((error: any) => handleError(error));
        } else {
            this.props.actions
                .new()
                .then(() => {
                    this.setState({
                        input: assign({}, this.props.emptyInput),
                        availableRoles: this.props.new.availableRoles,
                        availableCountries: this.props.new.availableCountries,
                        availableLanguages: this.props.new.availableLanguages
                    });
                })
                .catch((error: any) => handleError(error));
        }
    }

    onFormInputChange(e: any): void {
        let input = this.state.input;
        const value = e.target.value;

        input[e.target.name] = value;

        this.setState({ input: assign({}, input) });
    }

    save(): void {
        this.setState({ creating: true });
        if (this.props.editId > 0) {
            this.update();
        } else {
            this.checkForEmail();
            this.create();
        }
    }

    checkForEmail() {
        let input = this.state.input;

        if (!input.email && input.username) {
            input.email = input.username;

            this.setState({ input: assign({}, input) });
        }
    }

    create(): void {
        this.props.actions
            .create(this.state.input)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('se360users/notification/user-added'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    update(): void {
        this.props.actions
            .update(this.state.input)
            .then(() => {
                this.props.closeModal();
                notify.success(Translate('se360users/notification/user-updated'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    render(): any {
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.editId > 0
                                ? Translate('se360users/modal/title/edit-se360-user')
                                : Translate('se360users/modal/title/create-new-se360-user')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Se360UserForm
                            input={this.state.input}
                            onChange={this.onFormInputChange}
                            availableRoles={this.state.availableRoles}
                            availableLanguages={this.state.availableLanguages}
                            availableCountries={this.state.availableCountries}
                            isEditMode={this.props.editId > 0}
                            errors={this.state.errors}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('se360users/modal/footer/button-label/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={this.save}
                        >
                            {Translate('se360users/modal/footer/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        emptyInput: {
            id: -1,
            username: '',
            role: 0,
            roleTranslationKey: '',
            name: '',
            firstname: '',
            lastname: '',
            email: '',
            phoneNumber: '',
            languageKey: '',
            country: 0
        },
        edit: state.se360Users.edit,
        new: state.se360Users.new
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            new: () => dispatch(Actions.getNew()),
            create: (input: ISe360User) => dispatch(Actions.create(input)),
            edit: (id: number) => dispatch(Actions.edit(id)),
            update: (input: ISe360User) => dispatch(Actions.update(input))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Se360UserModal);
